import Table from '@/components/table/components/Table.tsx';
import messagesApi from '@/features/dashboard/messages/api/messagesApi.ts';
import { messagesApiQueryKeys } from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import {
  tourMessagesRoute,
  tourRoute,
} from '@/features/dashboard/tours/routes/tourRoute.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import useMessageRowActions from '@/features/dashboard/messages/hooks/useMessageRowActions.ts';

const TourMessagesTable = () => {
  const { tourId } = tourRoute.useParams();
  const search = tourMessagesRoute.useSearch();
  const rowContextMenuItems = useMessageRowActions(tourId);

  return (
    <Table
      listSearch={search}
      queryKey={messagesApiQueryKeys.byTour(tourId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        messagesApi.getScopedMessages({ tour: tourId }, pr, fc)
      }
      fetchTableDef={() =>
        messagesApi.getScopedTableDefinition({ tour: tourId })
      }
      rowContextMenuItems={rowContextMenuItems}
      title="Wiadomości"
    />
  );
};

export default TourMessagesTable;
